var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.230469,
    y: 0.984375,
    width: 45.6141,
    height: 45.6141,
    rx: 22.8071,
    fill: "#EB4176"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9228 14.1688C27.7854 14.1688 30.8829 16.6207 30.8829 20.6386H27.3939C27.3939 18.5507 25.5739 17.2388 22.8816 17.2388C20.6288 17.2388 18.3898 18.1592 18.3898 20.1166C18.3898 21.8885 20.1412 22.1839 23.1426 22.6303L24.056 22.7608C27.3596 23.2553 31.5697 23.894 31.5697 28.4613C31.5697 32.5616 28.1631 34.6357 23.1357 34.6357C17.6618 34.6357 14.5025 32.1838 14.5025 27.9874H17.9915C17.9915 30.2264 19.9489 31.5657 23.1014 31.5657C25.7936 31.5657 28.012 30.5835 28.012 28.475C28.012 26.5314 26.2126 26.2429 23.4654 25.8446L22.3115 25.6729C19.008 25.1921 14.8322 24.6014 14.8322 20.2745C14.8322 16.2567 18.4242 14.1688 22.9228 14.1688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.52cdbcb15db02105b0206a70804cd0e6.svg";
export { ForwardRef as ReactComponent };